'use es6';

import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["children"];
import { Component } from 'react';
import PropTypes from 'prop-types';
import Small from 'UIComponents/elements/Small';
import UILink from 'UIComponents/link/UILink';
import { jsx as _jsx } from "react/jsx-runtime";
export default class AddButton extends Component {
  render() {
    const _this$props = this.props,
      {
        children
      } = _this$props,
      rest = _objectWithoutPropertiesLoose(_this$props, _excluded);
    return /*#__PURE__*/_jsx(Small, {
      children: /*#__PURE__*/_jsx(UILink, Object.assign({}, rest, {
        children: children
      }))
    });
  }
}
AddButton.propTypes = {
  ['data-test-id']: PropTypes.string,
  children: PropTypes.node.isRequired,
  disabled: PropTypes.bool,
  onClick: PropTypes.func.isRequired
};